export enum BasketError {
    NO_UNIT_IN_ORDER = 1,
    CONTAINS_OUT_OF_RANGE_ITEM = 2,
    CUTOFF_DATE_REACHED = 3,
    MINIMUM_ORDER_AMOUNT_NOT_REACHED = 4,
    CONTAINS_UNAVAILABLE_ITEM = 5,
    UNACKNOWELDGED_WARNINGS = 6,
    CONTAINS_SAMPLES_AND_NON_SAMPLE_ITEMS = 7
}
